import { LikeList } from 'javascripts/like_list';
import { CustomLikeList } from 'javascripts/custom_like_list';
import { Timeline } from 'javascripts/timeline';
import KeenSlider from 'keen-slider';
import Attachment from '../../../javascripts/attachment';
import CommentForm from '../../../javascripts/comment_form';
import ImageZoomer from '../../../javascripts/components/ImageZoomer';
import Like from '../../../javascripts/components/Like';
import { CopyTarget } from '../../../javascripts/copy_target';
import ViewMode from '../../../javascripts/editor/view_mode';
import '../../../styles/layout/_editor';
import ReportReasonModal from '../../../javascripts/report_reason_modal';
import ReplyOmitted from '../../../javascripts/components/reply_omitted';
import ReplyCollapse from '../../../javascripts/components/reply_collapse';
import InfiniteScroll from '../../../javascripts/components/infinite_scroll';
import Confirm from '../../../javascripts/components/Confirm';
import Mute from '../../../javascripts/components/Mute';

if (!window?.Coorum) {
  window.Coorum = {};
}
window.Coorum.Like = Like;
window.Coorum.ImageZoomer = ImageZoomer;
window.Coorum.CommentForm = CommentForm;
window.Coorum.Attachment = Attachment;
window.Coorum.Mute = Mute;

const mute = new Coorum.Mute();

$(() => {
  const commentRootElement = document.querySelector('.comments-content');
  const comments = document.querySelectorAll('.p-answer');

  new ReplyOmitted('.js-reply-omitted');
  new ReplyCollapse('.js-reply-collapse');

  // 初回読み込みイベント
  comments.forEach((comment) => {
    mute.setMuteActions({ dataType: 'User', rootElement: comment });
    mute.addToggleMuteEvent({ rootElement: comment });
  });
  addActionEvent(document);
  new Timeline(timelineData.announcement_viewed_url);
  new LikeList('.c-like-list--other');
  new CustomLikeList('.c-custom-like-list--other');
  new Coorum.Like('.js-like');
  new Coorum.Favorite('.js-favorite', {
    button: { toggleMethod: ['post', 'delete'] },
  });
  const imageZoomer = new Coorum.ImageZoomer();
  imageZoomer.setGeneralEvent();
  imageZoomer.setCKEditorEvent(document.getElementById('editor'));
  new Coorum.CommentForm('.js-comment-form');
  document.querySelectorAll('[id^="report-reason-modal-"]').forEach((modal) => {
    new ReportReasonModal(modal.id);
  });
  document
    .querySelectorAll('.js-attachment')
    .forEach((elem) => new Coorum.Attachment({ spacing: 12 }, elem, true));
  new InfiniteScroll('.comments-container', '.p-answer', '.js-paginate a');
  const viewMode = new ViewMode();
  viewMode.replace();

  // 検知イベント
  const replyWrappers = document.querySelectorAll('.sent-replies');
  const replyMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node) => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          new ReplyOmitted('.js-reply-omitted', node);
        });
    });
  });
  replyWrappers.forEach((replyWrapper) => {
    replyMutation.observe(replyWrapper, { childList: true });
  });

  const docmentMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node) => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          mute.setMuteActions({ dataType: 'User', rootElement: node });
        });
    });
  });
  docmentMutation.observe(document.body, { childList: true });

  if (commentRootElement) {
    const commentRootMutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node) => node.nodeType === Node.ELEMENT_NODE)
          .forEach((node) => {
            new LikeList('.c-like-list--other', node);
            new CustomLikeList('.c-custom-like-list--other', node);
            new Coorum.Like('.js-like', false, node);
            new Coorum.ImageZoomer().setGeneralEvent(node);
            if (node.dataset.newComment === 'false') {
              Confirm.setEvents(node);
            }
            const attachment = node.querySelector('.js-attachment');
            if (attachment) {
              new Coorum.Attachment({ spacing: 12 }, attachment, true);
            }
            mute.addToggleMuteEvent({ rootElement: node });
            addActionEvent(node);

            node
              .querySelectorAll('[id^="report-reason-modal-"]')
              .forEach((modal) => {
                new ReportReasonModal(modal.id);
              });

            new ReplyOmitted('.js-reply-omitted', node);
            new ReplyCollapse('.js-reply-collapse', node);

            node.querySelectorAll('.sent-replies').forEach((replyWrapper) => {
              replyMutation.observe(replyWrapper, { childList: true });
            });

            node.querySelectorAll('oembed[url]').forEach((element) => {
              const viewMode = new ViewMode(element);
              viewMode.replace();
            });
          });
      });
    });
    commentRootMutation.observe(commentRootElement, { childList: true });
  }

  if (
    !document.querySelector('.c-Slider') ||
    !document.querySelector('.c-SliderController_Inner')
  )
    return;

  const maxSize = () =>
    window.matchMedia('(max-width: 768px)').matches ? 2 : 3;
  const arrow = {
    prev: document.querySelector('[data-arrow-prev]'),
    next: document.querySelector('[data-arrow-next]'),
  };

  const slideController = (child, parent) => {
    const addActive = (idx) => {
      child.slides[idx].classList.add('active');
    };

    addActive(child.track.details.rel);

    child.slides.forEach((slide, idx) => {
      slide.addEventListener('click', () => {
        if (idx !== 0) {
          child.moveToIdx(idx - 1);
        }
        parent.moveToIdx(idx);
      });
    });

    parent.on('animationStarted', (parent) => {
      child.slides.forEach((slide) => {
        slide.classList.remove('active');
      });

      const next = parent.animator.targetIdx || 0;
      addActive(parent.track.absToRel(next));
      child.moveToIdx(Math.min(child.track.details.maxIdx, next));
    });
  };

  const updateArrows = ({
    slides: { length },
    track: {
      details: { abs },
    },
  }) => {
    const { prev, next } = arrow;
    prev.setAttribute('data-disabled', true);
    next.setAttribute('data-disabled', true);

    if (length < maxSize() + 1) return;

    prev && abs === 0
      ? prev.setAttribute('data-disabled', true)
      : prev.setAttribute('data-disabled', false);

    next && length - maxSize() <= abs
      ? next.setAttribute('data-disabled', true)
      : next.setAttribute('data-disabled', false);
  };

  const checkComplete = ({ slides }) => {
    slides.forEach((slide) => {
      slide.style.visibility = 'visible';
    });
  };

  const slider = new KeenSlider('.c-Slider', {
    selector: '.c-Slider_Slide',
    created: (instance) => {
      checkComplete(instance);
    },
  });

  new KeenSlider('.c-SliderController_Inner', {
    selector: '.c-SliderController_Slide',
    initial: 0,
    slides: {
      perView: 'auto',
      spacing: 8,
    },
    created: (instance) => {
      checkComplete(instance);
      updateArrows(instance);
      slideController(instance, slider);
      arrow.prev.addEventListener('click', instance.prev);
      arrow.next.addEventListener('click', instance.next);
      window.addEventListener('resize', () => {
        updateArrows(instance);
      });
    },
    slideChanged: (instance) => {
      updateArrows(instance);
    },
  });
});

document.addEventListener('DOMContentLoaded', () => {
  new CopyTarget().attachClickEvents('.js-ticket_copy');

  $('[data-toggle="tooltip"]')
    .tooltip({
      trigger: 'manual',
      title: 'コピーしました',
      placement: 'bottom',
      container: 'body',
    })
    .on('click', function () {
      const $that = $(this);
      $that.tooltip('show');

      setTimeout(function () {
        $that.tooltip('hide');
      }, 3000);
    });
});

// 三点リーダーのボタンをクリックした時に表示を切り替えるイベントを登録する
function addActionEvent(rootElement = document) {
  rootElement.querySelectorAll('.js-action_btn').forEach((button) => {
    button.addEventListener('click', () => {
      button.querySelector('.js-action_body').classList.toggle('block');
    });
  });
}
